import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  OnDestroy,
  ViewChild,
  ChangeDetectorRef
} from "@angular/core";
import { of, Subscription } from "rxjs";
import { catchError, concatMap, finalize, mergeMap, tap } from "rxjs/operators";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormControl,
  FormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { ConfirmationService, MessageService } from "primeng/api";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import SignaturePad from "signature_pad";
import pdfjs from "@bundled-es-modules/pdfjs-dist/build/pdf";
import { PDFDocument, rgb } from "pdf-lib";
import { NgxExtendedPdfViewerService } from "ngx-extended-pdf-viewer";
import { Base64 } from "js-base64";
import { CanvasTextWrapper } from "canvas-text-wrapper";
import { Paginator } from "primeng/paginator";
import { AppGlobals } from "src/app/app.globals";
import { TranslateService } from "@ngx-translate/core";
import moment from "moment-timezone";
import { TranslationService } from "src/app/core/base/services/translation.service";
import { DocumentSignService } from "../../service/document-sign.service";
import {
  GetDocumentResponse,
  DocumentSigner,
  DocumentUrlMetaData,
  SignerContacts,
  SignType,
  SignMetadata,
  SignMetadataFormField,
  SignMetadataValues,
  TagObj,
  SimpleTag,
  TagsSignApply,
  BaseSignMetadata,
  BaseSignMetadataValues,
  ApiGetDocumentResponse,
} from "../../interfaces/document-sign.interface";
import { AppBreadcrumbService } from "../../../../core/breadcrumb/app.breadcrumb.service";
import {
  ContactTypeEnum,
  MetadataTypeEnum,
  SignerTypeEnum,
  SignTypeEnum,
} from "../../enums/document-sign.enum";
import { AuthErrorMessage } from "src/app/core/base/services/auth-token.service";

@Component({
  selector: "app-document-sign",
  templateUrl: "./document-sign.component.html",
  styleUrls: ["./document-sign.component.scss"],
  providers: [ConfirmationService, MessageService],
})
export class DocumentSignComponent implements OnInit, OnDestroy {
  @ViewChild('wacomSignature') wacomSignature: ElementRef;
  // Sottoscrizione per errori di autenticazione
  private authErrorSubscription: Subscription;

  // Flag per mostrare errori di autenticazione
  public displayAuthError: boolean = false;
  public authErrorMessage: string = "";
  public canRetryAuth: boolean = false;

  // Timer per il pulsante Riprova autenticazione
  public disabledBtnRetryAuth: boolean = false;
  public timerRetryAuth: any;
  public timerBtnRetryAuth: string = "";
  public countDownRetryAuth: number = 60;
  public reInitCountDownRetryAuth: number = 60;
  // 26/05/2022 Inizio: correzione bug 100164
  private _smaller_mobile_pdf_height: string = "60%";
  private _mobile_pdf_height: string = "70%";
  private _not_mobile_pdf_height: string = "85%";
  // 26/05/2022 Fine: correzione bug 100164

  private _documentUrl: string = "";
  private _document: DocumentUrlMetaData;
  private _fallback: string = "";
  private _guid: string = "";
  private _signer: string = "";
  private _documentSignRequest: GetDocumentResponse;
  private _typeSignFes: string = "";
  private _documentSignatures: Array<any> = [];
  private _documentMetadatas: Array<any> = [];
  private _signOTPDate: string = "";
  private _labelsLocale: any = null;

  private _offset_y_denied: number = 12;

  public activeLoader: boolean = true;
  public activeLoaderConfirmSignature: boolean = false;
  public displayModalFesSign: boolean = false;
  public displayModalFeaSign: boolean = false;
  public displayModalPrivacySign: boolean = false;
  public displayModalAlreadySigned: boolean = false;
  public displayModalDocumentExpired: boolean = false;
  public selectedFesSygnType: any = null;
  public fesSignTypes: Array<any> = [
    { name: "Firma con click", value: "click_sign" },
    { name: "Firma grafica", value: "graph_sign" },
  ];
  public currentSignature: number = 0;
  public currentMetadata: number = 0;
  public numberSignaturesDone: number = 0;
  public firstSignature: number = 0;
  public navigationCurrentSignature: number = 0;
  public totalSignatures: number = 0;
  public feaTotalSignatures: number = 0;
  public totalMetadatas: number = 0;
  public disabledBtnSign: boolean = false;
  public disabledBtnPrivacy: boolean = false;
  public disabledBtnConfirm: boolean = true;
  public disabledBtnGoBack: boolean = true;
  public disabledBtnResendOtp: boolean = false;
  public disabledInputMetadata: boolean = false;
  public disabledBtnApplyMetadata: boolean = false;
  public disabledBtnClearMetadata: boolean = false;
  public otpCodeInput: string;
  public initialPdfDocBase64: string;
  public initialPdfDoc: string;
  public pdfDocBase64: string;
  public pdfDoc: any;
  public readerPdfDoc: any;
  public realPdfDocBase64: string;
  public canvassContext: CanvasRenderingContext2D;
  public confirmTxtOtpSent: string = "";
  public timerResendOtp: any;
  public timerBtnResendOtp: string = "";
  public countDownResendOtp: number = 120;
  public reInitCountDownResendOtp: number = this.countDownResendOtp;
  public clinic: string = null;
  public operator: string = null;
  public signer: string = null;
  public languageSelected: string = null;
  public documentHasMetadata: boolean = false;
  public visibleMetadataSidebar: boolean = false;
  public heightPanelMetadata: string;
  public mobileHeightPanelMetadata: string;
  public initialSignMetadata: Array<SignMetadata> = [];
  public signMetadata: Array<SignMetadata> = [];
  public signMetadataFormatted: Array<SignMetadataFormField> = null;
  public signMetadataSetted: Array<SignMetadata> = null;
  public signMetadataValues: Array<SignMetadataValues> = [];

  // 26/05/2022 Inizio: correzione bug 100164
  public customHeight: string = this._not_mobile_pdf_height;
  public customReaderHeight: string = "100%";
  // 26/05/2022 Fine: correzione bug 100164

  public signAll: boolean = false;
  public displayModalError: boolean = false;
  public messageTitle: string = "";
  public messageDetail: string = "";
  public oauthMessage: string = "";
  public OauthToken: string = null;
  public showButtonConfirmSign: boolean = false;
  public isFegMode: boolean = false;
  public safePdfUrl: SafeResourceUrl = null; // Cache per l'URL sanitizzato
  private currentPage: number = 0;

  @ViewChild("sPad", { static: false }) signaturePadElement: ElementRef;
  @ViewChild("cSign", { static: false }) signatureCanvasElement: ElementRef;
  @ViewChild("cSignX", { static: false }) signatureXElement: ElementRef;
  @ViewChild("cMetadata", { static: false }) metadataCanvasElement: ElementRef;
  @ViewChild("paginator", { static: false }) paginator: Paginator;
  @ViewChild("paginatorMobile", { static: false }) paginatorMobile: Paginator;
  signaturePad: any;
  formMetadata: FormGroup;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private translate: TranslateService,
    private translation: TranslationService,
    private documentSignService: DocumentSignService,
    private breadcrumbService: AppBreadcrumbService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private ngxExtendedPdfViewerService: NgxExtendedPdfViewerService,
    private sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef
  ) {

    // PDF.js configuration to avoid sandboxing errors
    if (typeof window !== 'undefined') {
      (window as any).pdfjsWorker = {
        isMainThread: true
      };
      // Disable sandboxing globally
      (window as any).pdfjsLib = (window as any).pdfjsLib || {};
      (window as any).pdfjsLib.GlobalWorkerOptions = (window as any).pdfjsLib.GlobalWorkerOptions || {};
      (window as any).pdfjsLib.GlobalWorkerOptions.workerSrc = '/assets/worker/pdf.worker.js';

      // Completely disable sandboxing
      (window as any).pdfjsLib.GlobalWorkerOptions.isEvalSupported = false;
      (window as any).pdfjsLib.GlobalWorkerOptions.disableFontFace = true;
      (window as any).pdfjsLib.GlobalWorkerOptions.ignoreErrors = true;

      // Configuration to avoid sandboxing errors
      (window as any).pdfjsLib.GlobalWorkerOptions.sandboxBundleSrc = undefined;
      (window as any).pdfjsLib.GlobalWorkerOptions.disableAutoFetch = true;
      (window as any).pdfjsLib.GlobalWorkerOptions.disableRange = true;
      (window as any).pdfjsLib.GlobalWorkerOptions.disableStream = true;
    }

    let context = this;
    // 26/05/2022 Inizio: correzione bug 100164
    this.setPdfHeight();
    // 26/05/2022 Fine: correzione bug 100164
    let base64fallback =
      typeof context.activatedRoute.snapshot.paramMap.get("fallback") !==
        "undefined" &&
        context.activatedRoute.snapshot.paramMap.get("fallback") != null
        ? context.activatedRoute.snapshot.paramMap.get("fallback")
        : null;
    context._documentUrl =
      context.activatedRoute.snapshot.paramMap.get("document");
    localStorage.setItem("fallback", base64fallback);
    if (window.history.length > 1) {
      context.disabledBtnGoBack = false;
    }
    if (
      typeof context.activatedRoute.snapshot.paramMap.get("locale") !==
      "undefined" &&
      context.activatedRoute.snapshot.paramMap.get("locale") != null
    ) {
      let localeParam = context.activatedRoute.snapshot.paramMap.get("locale");
      try { localeParam = Base64.decode(localeParam) || localeParam; } catch (_) { }
      const checkLangExistence = (langParam) =>
        AppGlobals.getParam("locales").some(({ code }) => code == langParam);
      if (checkLangExistence(localeParam)) {
        context.translation.setLanguage(localeParam);
      }
    }
    context.languageSelected = context.translation.getSelectedLanguage();
    try {
      context._document = JSON.parse(Base64.decode(context._documentUrl));
      if (
        typeof context._document.documentID !== "undefined" &&
        typeof context._document.signerID !== "undefined"
      ) {
        context._guid = context._document.documentID;
        context._signer = context._document.signerID;
      }
      if (base64fallback != null) {
        context._fallback = Base64.decode(base64fallback);
      }
    } catch (error) {
      console.error(error);
    }
    context.translate
      .get([
        "documentSign.title",
        "documentSign.mustSelectSignType",
        "documentSign.signedIntoCanvass",
        "documentSign.genericErrorOnSignature",
        "documentSign.genericError",
        "documentSign.otpSentSuccessfully",
        "documentSign.notPossibleOtpSend",
        "documentSign.mustInsertOtp",
        "documentSign.otpErrorNotValid",
        "documentSign.genericErrorOnSignature",
        "documentSign.buttonPrivacy",
        "documentSign.yesPrivacyButton",
        "documentSign.noPrivacyButton",
        "documentSign.documentSignedSuccessfullyWithFallback",
        "documentSign.documentSignedSuccessfully",
        "documentSign.documentSigned",
        "documentSign.okButton",
        "documentSign.messageSendOtpByEmail",
        "documentSign.messageSendOtpByMobile",
        "documentSign.titleSendOtp",
        "documentSign.buttonSendOtp",
        "documentSign.cancel",
        "documentSign.otpSentToEmail",
        "documentSign.otpSentToMobile",
        "documentSign.date",
        "documentSign.otp",
        "documentSign.signatureDoneDigitally",
        "documentSign.error",
        "documentSign.warning",
        "documentSign.otpSended",
        "documentSign.refresh_page",
      ])
      .subscribe({
        next: (res) => {
          context._labelsLocale = res;
          context.breadcrumbService.setItems([
            { label: context._labelsLocale["documentSign.title"] },
          ]);
          if (context._guid !== "" && context._signer !== "") {
            context.getDocumentToBeSigned(context._guid, context._signer);
          }
        },
        error: () => {
          context._labelsLocale = {};
          if (context._guid !== "" && context._signer !== "") {
            context.getDocumentToBeSigned(context._guid, context._signer);
          }
        }
      });

    // Sottoscrizione agli errori di autenticazione
    this.authErrorSubscription = this.documentSignService.authErrors$.subscribe(
      (error: AuthErrorMessage) => {
        this.handleAuthError(error);
      }
    );
  }

  /**
   * Cleanup delle sottoscrizioni
   */
  ngOnDestroy(): void {
    if (this.authErrorSubscription) {
      this.authErrorSubscription.unsubscribe();
    }
    if (this.timerRetryAuth) {
      clearInterval(this.timerRetryAuth);
    }
    this.breadcrumbService.setCenterLabel("");
  }

  /**
   * Gestisce gli errori di autenticazione mostrando un messaggio user-friendly
   */
  private handleAuthError(error: AuthErrorMessage): void {
    this.displayAuthError = true;
    this.authErrorMessage = error.userFriendlyMessage;
    this.canRetryAuth = error.canRetry;
    this.activeLoader = false;
  }

  /**
   * Riprova l'operazione dopo un errore di autenticazione
   */
  public retryAfterAuthError(): void {
    if (this.disabledBtnRetryAuth) {
      return;
    }

    this.displayAuthError = false;
    this.authErrorMessage = "";
    this.activeLoader = true;

    // Avvia il timer di countdown per evitare click ripetuti
    this.startTimerRetryAuth();

    // Ricarica il documento
    if (this._guid && this._signer) {
      this.getDocumentToBeSigned(this._guid, this._signer);
    }
  }

  /**
   * Avvia il timer di countdown per il pulsante Riprova
   */
  public startTimerRetryAuth(): void {
    let context = this,
      valueTimer = context.countDownRetryAuth,
      minutes: number,
      seconds: number,
      strMinutes: string,
      strSeconds: string;

    context.disabledBtnRetryAuth = true;
    context.timerRetryAuth = setInterval(() => {
      minutes = parseInt((valueTimer / 60).toString(), 10);
      seconds = parseInt((valueTimer % 60).toString(), 10);

      strMinutes = minutes < 10 ? "0" + minutes : minutes.toString();
      strSeconds = seconds < 10 ? "0" + seconds : seconds.toString();

      context.timerBtnRetryAuth = strMinutes + ":" + strSeconds;
      if (--valueTimer < 0) {
        context.clearTimerRetryAuth();
      }
    }, 1000);
  }

  /**
   * Pulisce il timer di countdown per il pulsante Riprova
   */
  public clearTimerRetryAuth(): void {
    clearInterval(this.timerRetryAuth);
    this.countDownRetryAuth = this.reInitCountDownRetryAuth;
    this.timerBtnRetryAuth = "";
    this.disabledBtnRetryAuth = false;
  }

  /**
   * Chiude il dialog di errore di autenticazione
   */
  public dismissAuthError(): void {
    this.displayAuthError = false;
    this.authErrorMessage = "";

    // Se non è possibile riprovare, reindirizza al fallback
    if (!this.canRetryAuth && this._fallback) {
      location.href = this._fallback;
    }
  }

  // 26/05/2022 Inizio: correzione bug 100164
  getAbsoluteHeight(el) {
    // Get the DOM Node if you pass in a string
    var ctrl = el;
    el = typeof el === "string" ? document.querySelector(el) : el;

    var styles = window.getComputedStyle(el);
    var margin =
      parseFloat(styles["marginTop"]) + parseFloat(styles["marginBottom"]);

    return parseFloat(styles.height) + margin;
  }

  setPdfHeight() {
    var calcHeight = 0;
    this.customHeight = this._mobile_pdf_height;
    this.customReaderHeight = "100%";

    if (document.getElementsByClassName("info-signature").length > 0) {
      const el = document.getElementsByClassName("info-signature")[0]
      calcHeight += this.getAbsoluteHeight(el);
    }
    if (document.getElementsByClassName("recap-signatures").length > 0) {
      const el = document.getElementsByClassName("recap-signatures")[0]
      calcHeight += this.getAbsoluteHeight(el);
    }
    if (document.getElementsByClassName("paginatorBlock").length > 0) {
      const el = document.getElementsByClassName("paginatorBlock")[0]
      calcHeight += this.getAbsoluteHeight(el);
    }

    var totalHeight = this.getAbsoluteHeight(".layout-main-content");
    var perc = Math.ceil(((totalHeight - calcHeight) * 100) / totalHeight) - 1;

    if (perc == 0 || perc > 85) {
      if (this.isMobile()) {
        if (this.isSmallerScreen()) {
          this.customHeight = this._smaller_mobile_pdf_height;
        } else {
          this.customHeight = this._mobile_pdf_height;
        }
      } else {
        this.customHeight = this._not_mobile_pdf_height;
      }
      this.customReaderHeight = "100%";
    } else {
      this.customHeight = perc + "%";
      this.customReaderHeight = "100%";
    }
  }
  // 26/05/2022 Fine: correzione bug 100164

  convertToNumber(): number {
    return Number(this.customHeight.replace("%", ""))
  }

  ngOnInit(): void {
    // Disable sandboxing to avoid errors
    if (typeof window !== 'undefined') {
      // PDF.js configuration to avoid sandboxing errors
      if ((window as any).pdfjsLib) {
        (window as any).pdfjsLib.GlobalWorkerOptions.workerSrc = '/assets/worker/pdf.worker.js';
        (window as any).pdfjsLib.GlobalWorkerOptions.isEvalSupported = false;
        (window as any).pdfjsLib.GlobalWorkerOptions.disableFontFace = true;
        (window as any).pdfjsLib.GlobalWorkerOptions.ignoreErrors = true;
      }

      // Sandbox disabled
      if ((window as any).PDFViewerApplication) {
        (window as any).PDFViewerApplication.externalServices = {
          ...((window as any).PDFViewerApplication.externalServices || {}),
          createSandbox: () => null,
          destroySandbox: () => { },
          supported: false
        };
      }
    }

    // type solo da path (segmento base64)
    const typeBase64 = this.activatedRoute?.snapshot?.paramMap?.get('type');
    let type: string | null = null;
    if (typeBase64) {
      try { type = Base64.decode(typeBase64); } catch (_) { type = typeBase64; }
    }
    this.isFegMode = type === 'FEG';
    this.updateCenterRoleLabel();

    if (this._guid == "" || this._signer == "") {
      location.href = "";
    }
  }

  // 26/05/2022 Inizio: correzione bug 100164
  ngAfterContentChecked(): void {
    this.setPdfHeight();
  }
  // 26/05/2022 Fine: correzione bug 100164

  ngAfterViewInit(): void {
    // 26/05/2022 Inizio: correzione bug 100164
    this.setPdfHeight();
    // 26/05/2022 Fine: correzione bug 100164

    // Intercept sandboxing errors PDF.js
    if (typeof window !== 'undefined') {
      const originalConsoleError = console.error;
      console.error = (...args: any[]) => {
        // Filter sandboxing errors PDF.js
        const errorMessage = args.join(' ');
        if (errorMessage.includes('callSandboxFunction') ||
          errorMessage.includes('pdf.sandbox.js') ||
          errorMessage.includes('GenericScripting') ||
          errorMessage.includes('PDFScriptingManager')) {
          // Do not show these errors in console
          return;
        }
        originalConsoleError.apply(console, args);
      };

      // Intercept unhandled promise rejections related to sandboxing
      window.addEventListener('unhandledrejection', (event) => {
        if (event.reason && event.reason.message &&
          event.reason.message.includes('callSandboxFunction')) {
          event.preventDefault();
        }
      });
    }

    this.signaturePad = new SignaturePad(
      this.signaturePadElement.nativeElement
    );
    this.signaturePad.off();
    this.setHeightPanelMetadata();
    this.setupWacomListeners(); // Attach listeners once
  }

  private setupWacomListeners() {
    if (this.wacomSignature && this.wacomSignature.nativeElement) {
      const component = this.wacomSignature.nativeElement;
      component.addEventListener('signed', (e: any) => {
        this.handleWacomSignature(e.detail);
      });

      component.addEventListener('cancelled', () => { });
    }
  }

  public goBack() {
    window.history.back();
  }

  public showDialogSign(signAll: boolean) {
    if (
      !this.disabledBtnSign &&
      this.currentSignature > 0 &&
      this._documentSignatures.length > 0
    ) {
      let currentDocumentSignature = this.getCurrentDocumentSignature();
      if (this.isFegMode) {
        if (currentDocumentSignature?.sign?.type == SignTypeEnum.PRIVACY) {
          this.showDialogPrivacy();
        } else {
          this.openWacomSignature();
        }
      } 
      else {
        if (currentDocumentSignature.sign.type == SignTypeEnum.FES) {
          this.showModalDialogFesSign();
        } else if (currentDocumentSignature.sign.type == SignTypeEnum.PRIVACY) {
          this.showDialogPrivacy();
        } else if (currentDocumentSignature.sign.type == SignTypeEnum.FEA) {
          if (signAll == null) {
            this.signAll = false;
          }
          else {
            this.signAll = signAll;
          }
          this.confirmSendOtp();
        }
      }
    }
  }

  private openWacomSignature() {
    const component = this.wacomSignature.nativeElement;
    this.setWacomSignatureAttributes(component);
    // Apro il componente
    component.openSignature();
  }

  private setWacomSignatureAttributes(component: any) {
    const signer = this._documentSignRequest.document.signers.find(s => s.signerID === this._signer);
    const patientName = signer ? `${signer.name} ${signer.surname}` : '';
    component.setAttribute('patient-name', patientName);
    component.setAttribute('certificate-country', (this.languageSelected || '').toLowerCase());
    component.setAttribute('certificate-test', this.documentSignService.isTestEnvironment() ? 'true' : 'false');

    // Current PDF base64 (already updated if previous signatures exist).
    const pdfBase64 = this.realPdfDocBase64 || this.initialPdfDocBase64;
    component.setAttribute('pdf-document', pdfBase64);

    const currentDocumentSignature = this.getCurrentDocumentSignature();
    if (currentDocumentSignature && currentDocumentSignature.sign) {
      component.setAttribute('tag-name', currentDocumentSignature.sign.tag);
    }

    if (this.isFegMode) {
      component.setAttribute('signature-role-label', this.getFegSignatureRoleLabel());
    } else {
      component.removeAttribute('signature-role-label');
    }
  }

  private async handleWacomSignature(signatureData: any) {
    if (signatureData.success && signatureData.signedPdf) {
        
        // Aggiorno il PDF corrente con quello firmato restituito dal backend
        this.realPdfDocBase64 = signatureData.signedPdf;
        this.pdfDocBase64 = signatureData.signedPdf;
        this.safePdfUrl = this.getSafeUrl(this.pdfDocBase64);
        
        // Ricarico le istanze di pdf-lib per le prossime operazioni
        this.pdfDoc = await PDFDocument.load(this.realPdfDocBase64);
        this.readerPdfDoc = await PDFDocument.load(this.realPdfDocBase64);

        // Marco la firma corrente come completata
        let currentDocumentSignature = this.getCurrentDocumentSignature();
        if (currentDocumentSignature) {
            // Aggiorno l'oggetto corrente (reference)
            currentDocumentSignature.isSigned = true;
            currentDocumentSignature.signatureTime = new Date().toUTCString();

            // Aggiorno il contatore delle firme FEA rimanenti
            let signer = this.getCurrentSigner();
            this.feaTotalSignatures = this._documentSignatures.filter(signature =>
              signature.type === "FEA" && !signature.isSigned && signature.sign.signerID === signer?.signerID
            ).length;
        }

        // Aggiorno UI
        this.highlightSignature();
        this.refreshSignatureDone();
        
        // Chiudo la modale (simulando successo come in confirmFesSign)
        await this.closeDialogSign(true, true);
    } else {
        console.error('Errore o firma vuota', signatureData);
        this.messageService.add({
            severity: "error",
            summary: this._labelsLocale["documentSign.error"],
            detail: signatureData.errorMessage || "Errore durante la firma Wacom"
        });
    }
  }

  public showDialogPrivacy() {
    if (
      !this.disabledBtnPrivacy &&
      this.currentSignature > 0 &&
      this._documentSignatures.length > 0
    ) {
      this.showModalDialogPrivacySign();
    }
  }

  public async closeDialogSign(updateCurrentSignature: boolean, forceUpdate: boolean) {
    let context = this,
      currentDocumentSignature = context.getCurrentDocumentSignature();
    if (currentDocumentSignature == null) return;

    if (currentDocumentSignature.sign.type == SignTypeEnum.FES) {
      context.hideModalDialogFesSign();
    } else if (currentDocumentSignature.sign.type == SignTypeEnum.FEA) {
      context.hideModalDialogFeaSign();
    } else if (currentDocumentSignature.sign.type == SignTypeEnum.PRIVACY) {
      context.hideModalDialogPrivacySign();
    }
    if (
      context.numberSignaturesDone < context.totalSignatures &&
      updateCurrentSignature
    ) {
      context.currentSignature++;
    }

    await context.clearCanvasSignImg();
    context.clearMessages();
    context._signOTPDate = "";
    await context.updateCurrentPage(context.currentSignature - 1, forceUpdate);
    this.updateCenterRoleLabel();
  }

  public setFesSygnType(event: any) {
    let context = this;
    if (event != null) {
      if (typeof context.selectedFesSygnType !== "undefined") {
        context._typeSignFes = context.selectedFesSygnType.value;
        context.clearMessages();
        if (context._typeSignFes != "graph_sign") {
          context.signaturePad.off();
        } else {
          context.signaturePad.on();
        }
      }
    }
  }

  public clearSignaturePad() {
    this.signaturePad.clear();
  }

  public clearMessages() {
    this.messageService.clear();
  }

  public paginateSignature(event: any) {
    this.currentPage = event.page;
    this.currentSignature = event.page + 1;
    this.updateCenterRoleLabel();
    setTimeout(() => {
      this.handlePageChange(this.currentPage);
    }, 500);

  }

  private handlePageChange(page: number) {
    if (page >= 0 && page < this._documentSignatures.length) {
      const tag = this._documentSignatures[page].sign.tag;
      if (tag != null && this.ngxExtendedPdfViewerService != null)
        this.ngxExtendedPdfViewerService.find(tag, { matchCase: true });
    }
  }

  public metadataPaginateSignature(tag: string) {
    if (tag !== "undefined") {
      this.ngxExtendedPdfViewerService.find(tag, { matchCase: true });
    }
  }

  public async confirmPrivacy(answer: boolean) {
    let context = this;
    let currentDocumentSignature = context.getCurrentDocumentSignature();
    if (currentDocumentSignature == null) {
      return;
    }

    if (currentDocumentSignature.signatureTime == null) {
      currentDocumentSignature.signatureTime = new Date().toUTCString();
    }

    // In FEG mode PRIVACY uses standard FEA flow (local draw + final sign/apply backend).
    if (context.isFegMode) {
      context.hideModalDialogPrivacySign();
      if (answer) {
        await this.applyPrivacySignatureLocal(currentDocumentSignature, answer);
      }
      return;
    }

    await this.applyPrivacySignatureLocal(currentDocumentSignature, answer);
  }

  private async applyPrivacySignatureLocal(currentDocumentSignature: any, answer: boolean): Promise<void> {
    let context = this;

    let choice: string,
      choiceScale: number,
      choiceX: number = currentDocumentSignature.offset.x,
      choiceY: number = currentDocumentSignature.offset.y;

    if (!answer) {
      choiceY = choiceY - 20;
    } else {
      choiceY = choiceY + 5;
    }

    choice = context.createCheck();
    choiceScale =
      currentDocumentSignature.scaling != null
        ? currentDocumentSignature.scaling
        : 0.4;

    context.pdfDocBase64 = await context.readerPdfDoc.saveAsBase64({
      dataUri: false,
    });
    context.pdfDoc = await PDFDocument.load(context.pdfDocBase64);
    let pagesPdfDoc = await context.pdfDoc.getPages(),
      pagePdfDoc = pagesPdfDoc[currentDocumentSignature.page],
      signImagePdfDoc = await context.pdfDoc.embedPng(choice),
      pngDims = await signImagePdfDoc.scale(choiceScale);

    await pagePdfDoc.drawImage(signImagePdfDoc, {
      x: currentDocumentSignature.x - pngDims.width / 2 + choiceX,
      y: currentDocumentSignature.y - pngDims.height + choiceY,
      width: pngDims.width,
      height: pngDims.height,
    });

    context.pdfDocBase64 = await context.pdfDoc.saveAsBase64({
      dataUri: false,
    });
    context.realPdfDocBase64 = context.pdfDocBase64;
    context.pdfDoc = await PDFDocument.load(context.pdfDocBase64);
    context.readerPdfDoc = await PDFDocument.load(context.realPdfDocBase64);

    currentDocumentSignature.isSigned = true;
    context.highlightSignature();
    context.refreshSignatureDone();
    await context.closeDialogSign(true, true);
  }

  public async confirmFesSign() {
    let context = this;

    if (context._typeSignFes == "") {
      this.messageService.add({
        severity: "error",
        summary: context._labelsLocale["documentSign.error"] + ":",
        detail: context._labelsLocale["documentSign.mustSelectSignType"],
      });
      var contextToString = this.anyToStringJSON(context)
      this.sendError(context._documentUrl, "confirmFesSign", "if (context._typeSignFes == '')", contextToString, null);
      return;
    }

    if (
      context._typeSignFes == "graph_sign" &&
      context.signaturePad.isEmpty()
    ) {
      this.messageService.add({
        severity: "error",
        summary: context._labelsLocale["documentSign.error"] + ":",
        detail: context._labelsLocale["documentSign.signedIntoCanvass"],
      });
      var contextToString = this.anyToStringJSON(context)
      this.sendError(context._documentUrl, "confirmFesSign", "if (context._typeSignFes == 'graph_sign') && context.signaturePad.isEmpty()", contextToString, null);
      return;
    }

    if (context.currentSignature > 0) {
      let currentDocumentSignature = context.getCurrentDocumentSignature();

      if (currentDocumentSignature.signatureTime == null) {
        currentDocumentSignature.signatureTime = new Date().toUTCString();
      }
      currentDocumentSignature.isSigned = true;

      if (typeof currentDocumentSignature === "undefined") {
        this.messageService.add({
          severity: "error",
          summary: context._labelsLocale["documentSign.error"] + ":",
          detail: context._labelsLocale["documentSign.genericErrorOnSignature"],
        });
        var contextToString = this.anyToStringJSON(context)
        this.sendError(context._documentUrl, "confirmFesSign", "typeof currentDocumentSignature === 'undefined'", contextToString, null);
        return;
      }

      let imgSign: string,
        imgScale: number,
        imgTransX: number = currentDocumentSignature.offset.x,
        imgTransY: number = currentDocumentSignature.offset.y;
      if (context._typeSignFes == "graph_sign") {
        imgSign = context.signaturePad.toDataURL();
        imgScale =
          currentDocumentSignature.scaling != null
            ? currentDocumentSignature.scaling
            : 0.35;
      } else {
        imgSign = context.createSignImg();
        imgScale =
          currentDocumentSignature.scaling != null
            ? currentDocumentSignature.scaling
            : 0.4;
      }

      context.pdfDocBase64 = await context.readerPdfDoc.saveAsBase64({
        dataUri: false,
      });
      context.pdfDoc = await PDFDocument.load(context.pdfDocBase64);

      let pagesPdfDoc = await context.pdfDoc.getPages()
      let pagePdfDoc = pagesPdfDoc[currentDocumentSignature.page]
      let signImagePdfDoc = await context.pdfDoc.embedPng(imgSign)
      let pngDims = await signImagePdfDoc.scale(imgScale)

      await pagePdfDoc.drawImage(signImagePdfDoc, {
        x: currentDocumentSignature.x - pngDims.width / 2 + imgTransX,
        y: currentDocumentSignature.y - pngDims.height + imgTransY,
        width: pngDims.width,
        height: pngDims.height,
      });

      context.pdfDocBase64 = await context.pdfDoc.saveAsBase64({
        dataUri: false,
      });
      context.realPdfDocBase64 = context.pdfDocBase64;
      context.pdfDoc = await PDFDocument.load(context.pdfDocBase64);
      context.readerPdfDoc = await PDFDocument.load(context.realPdfDocBase64);

      currentDocumentSignature.isSigned = true;
      context.highlightSignature();
      context.refreshSignatureDone();
      await context.closeDialogSign(true, true);
    }
  }

  public setHeightPanelMetadata() {
    this.heightPanelMetadata = window.innerHeight / 2.05 + "px";
    this.mobileHeightPanelMetadata = window.innerHeight / 1.75 + "px";
  }

  public openMetadataSidebar() {
    this.visibleMetadataSidebar = true;
  }

  public closeMetadataSidebar() {
    this.visibleMetadataSidebar = false;
  }

  public metadataFieldIsValid(field: string): boolean {
    let context = this;
    return (
      context.formMetadata.get(field)?.invalid &&
      (context.formMetadata.get(field)?.dirty ||
        context.formMetadata.get(field)?.touched)
    );
  }

  public async clearMetadataTags() {
    let context = this;
    await context.updatePdfAfterDrawn(context.initialPdfDocBase64);
    context.resetSignMetadataAndMetadataValues();
    context.formMetadata.reset();
    context.createInputOnMetadataType(context.initialSignMetadata);
    context.disabledBtnSign = true;
  }

  public onSubmitFormMetadata() {
    let context = this;
    if (!context.formMetadata.valid) {
      context.disabledBtnSign = true;
    } else {
      if (context.disabledBtnSign) {
        context.disabledBtnSign = false;
      }
      context.applyMetadataTags();
    }
  }

  private setSignMetadataAndMetadataValues(formValues: any) {
    let context = this;
    context.resetSignMetadataAndMetadataValues();

    Object.keys(formValues).map((formValueKey: string) => {
      const formValue = formValues[formValueKey];
      const indexMetadataForm = context.signMetadataFormatted.findIndex(
        (item: SignMetadataFormField) => item.key == formValueKey
      );
      const metadataItem: SignMetadataFormField =
        context.signMetadataFormatted[indexMetadataForm];
      const indexMetadata = context.signMetadata.findIndex(
        (item: SignMetadata) =>
          item.metadataID ===
          context.signMetadataFormatted[indexMetadataForm].metadataID
      );

      if (
        metadataItem.metadataType == MetadataTypeEnum.TEXT ||
        metadataItem.metadataType == MetadataTypeEnum.DROPDOWN
      ) {
        context.signMetadataValues.push({
          signMetadataID: metadataItem.metadataID,
          value: formValue,
        });
        context.signMetadata[indexMetadata].isCompleted = true;
        context.signMetadata[indexMetadata].metadataTimeCompleted =
          new Date().toUTCString();
      } else if (metadataItem.metadataType == MetadataTypeEnum.CHECKBOX) {
        formValue.map((value: string) => {
          const metadata: SignMetadata = metadataItem.items.find(
            (item: SignMetadata) => item.acceptedValues.includes(value)
          );
          const indexSMetadata = context.signMetadata.findIndex(
            (item: SignMetadata) => item.metadataID === metadata.metadataID
          );
          context.signMetadataValues.push({
            signMetadataID: metadata.metadataID,
            value: value,
            groupName: metadata.groupName,
          });
          context.signMetadata[indexSMetadata].isCompleted = true;
          context.signMetadata[indexSMetadata].metadataTimeCompleted =
            new Date().toUTCString();
        });
      } else if (metadataItem.metadataType == MetadataTypeEnum.RADIO) {
        const metadata: SignMetadata = metadataItem.items.find(
          (item: SignMetadata) => item.acceptedValues.includes(formValue)
        );
        const indexSMetadata = context.signMetadata.findIndex(
          (item: SignMetadata) => item.metadataID === metadata.metadataID
        );
        context.signMetadataValues.push({
          signMetadataID: metadata.metadataID,
          value: formValue,
          groupName: metadata.groupName,
        });
        context.signMetadata[indexSMetadata].isCompleted = true;
        context.signMetadata[indexSMetadata].metadataTimeCompleted =
          new Date().toUTCString();
      }
    });
  }

  private resetSignMetadataAndMetadataValues() {
    let context = this;
    context.signMetadataValues = [];
    context.signMetadata = context.signMetadata.map((item: SignMetadata) => {
      item.isCompleted = false;
      item.metadataTimeCompleted = undefined;
      return item;
    });
  }

  public async applyMetadataTags() {
    let context = this;
    let metadataImages = [];
    context.activeLoader = true;

    context.setSignMetadataAndMetadataValues(
      context.formMetadata.getRawValue()
    );

    context.signMetadataValues.map((metadataValue: SignMetadataValues) => {
      let currentSignMetadata = context._documentMetadatas.find(
        (metaItem: any) =>
          metaItem.metadata.metadataID === metadataValue.signMetadataID
      );
      if (typeof currentSignMetadata !== "undefined") {
        if (
          metadataValue.value != "" &&
          (currentSignMetadata.type == MetadataTypeEnum.TEXT ||
            currentSignMetadata.type == MetadataTypeEnum.DROPDOWN)
        ) {
          metadataImages.push({
            content: context.createMetadataImg(metadataValue.value),
            x: currentSignMetadata.x,
            y: currentSignMetadata.y,
            transX: currentSignMetadata.offset.x,
            transY: currentSignMetadata.offset.y,
            scale:
              currentSignMetadata.scaling != null
                ? currentSignMetadata.scaling
                : 0.5,
            page: currentSignMetadata.page,
            documentMetadata: currentSignMetadata,
          });

          context.clearCanvasMetadataImg();
        } else if (
          metadataValue.value != "" &&
          (currentSignMetadata.type == MetadataTypeEnum.CHECKBOX ||
            currentSignMetadata.type == MetadataTypeEnum.RADIO)
        ) {
          metadataImages.push({
            content: context.createMetadataImg("X"),
            x: currentSignMetadata.x,
            y: currentSignMetadata.y,
            transX: currentSignMetadata.offset.x,
            transY: currentSignMetadata.offset.y,
            scale:
              currentSignMetadata.scaling != null
                ? currentSignMetadata.scaling
                : 0.5,
            page: currentSignMetadata.page,
            documentMetadata: currentSignMetadata,
          });

          context.clearCanvasMetadataImg();
        }
      }
    });

    context.drawMultipleMetadataImages(metadataImages);
    context.activeLoader = false;
  }

  public resendOtp() {
    if (this.disabledBtnResendOtp) {
      return;
    }

    let context = this,
      currentDocumentSignature = context.getCurrentDocumentSignature(),
      tag: SimpleTag = {
        tagID: currentDocumentSignature.sign.tagID,
        tag: currentDocumentSignature.sign.tag,
      };

    context.activeLoader = true;
    context.documentSignService
      .sendOtpToSignDocumentRequest(
        context._documentUrl,
        tag,
        this.languageSelected,
        this.signAll
      )
      .pipe(
        tap((response) => {
          var responseString = this.anyToStringJSON(response.data)
          if (!response.data.sent) {
            context.messageService.add({
              severity: "error",
              summary: context._labelsLocale["documentSign.error"] + ":",
              detail: context._labelsLocale["documentSign.genericError"],
            });
            this.sendError(context._documentUrl, "resendOtp", "sendOtpToSignDocumentRequest", "if (!response.data.sent)", responseString);
            return of();
          }

          if (typeof response.data.signerTag.signerID === "undefined") {
            context.messageService.add({
              severity: "error",
              summary: context._labelsLocale["documentSign.error"] + ":",
              detail: context._labelsLocale["documentSign.genericError"],
            });
            this.sendError(context._documentUrl, "resendOtp", "sendOtpToSignDocumentRequest", "signerID is undefined", responseString);
            return of();
          }

          if (
            response.data.signerTag.signerID !=
            currentDocumentSignature.sign.signerID
          ) {
            context.messageService.add({
              severity: "error",
              summary: context._labelsLocale["documentSign.error"] + ":",
              detail: context._labelsLocale["documentSign.genericError"],
            });
            var currentDocumentSignatureToString = this.anyToStringJSON(currentDocumentSignature)
            this.sendError(context._documentUrl, "resendOtp", "sendOtpToSignDocumentRequest", responseString, currentDocumentSignatureToString);
            return of();
          }

          let tagResponse = context.getObjectFromList(
            currentDocumentSignature.sign.tagID,
            "tagID",
            response.data.signerTag.tags
          );

          if (typeof tagResponse === "undefined") {
            context.messageService.add({
              severity: "error",
              summary: context._labelsLocale["documentSign.error"] + ":",
              detail: context._labelsLocale["documentSign.genericError"],
            });
            var contextToString = this.anyToStringJSON(contextToString)
            var currentDocumentSignatureToString = this.anyToStringJSON(currentDocumentSignature)
            this.sendError(context._documentUrl, "resendOtp", "sendOtpToSignDocumentRequest => undefined", contextToString, "response => " + responseString + "\n\n" + "currentDocumentSignature => " + currentDocumentSignatureToString);
            return of();
          }

          if (tagResponse.tagID != currentDocumentSignature.sign.tagID) {
            context.messageService.add({
              severity: "error",
              summary: context._labelsLocale["documentSign.error"] + ":",
              detail: context._labelsLocale["documentSign.genericError"],
            });
            var contextToString = this.anyToStringJSON(contextToString)
            var currentDocumentSignatureToString = this.anyToStringJSON(currentDocumentSignature)
            this.sendError(context._documentUrl, "resendOtp", "sendOtpToSignDocumentRequest => tagResponse.tagID != currentDocumentSignature.sign.tagID", contextToString, "response => " + responseString + "\n\n" + "currentDocumentSignature => " + currentDocumentSignatureToString);
            return of();
          }

          context.messageService.add({
            severity: "success",
            summary: context._labelsLocale["documentSign.otpSended"] + ":",
            detail: context._labelsLocale["documentSign.otpSentSuccessfully"],
          });
          context.startTimerResendOtp();
        }),
        catchError((err, caught) => {
          context.messageService.add({
            severity: "error",
            summary: context._labelsLocale["documentSign.error"] + ":",
            detail: context._labelsLocale["documentSign.notPossibleOtpSend"],
          });
          var exception = this.getExceptionMessage(err)
          this.sendError(context._documentUrl, "resendOtp", "sendOtpToSignDocumentRequest", exception, "catchError");
          return of();
        }),
        finalize(() => {
          context.activeLoader = false;
        })
      )
      .subscribe();
  }

  public startTimerResendOtp() {
    let context = this,
      valueTimerResend = context.countDownResendOtp,
      minutes: number,
      seconds: number,
      strMinutes: string,
      strSeconds: string;
    context.timerResendOtp = setInterval(() => {
      minutes = parseInt((valueTimerResend / 60).toString(), 10);
      seconds = parseInt((valueTimerResend % 60).toString(), 10);

      strMinutes = minutes < 10 ? "0" + minutes : minutes.toString();
      strSeconds = seconds < 10 ? "0" + seconds : seconds.toString();

      context.disabledBtnResendOtp = true;
      context.timerBtnResendOtp = strMinutes + ":" + strSeconds;
      if (--valueTimerResend < 0) {
        context.clearTimerResendOtp();
      }
    }, 1000);
  }

  public clearTimerResendOtp() {
    clearInterval(this.timerResendOtp);
    this.countDownResendOtp = this.reInitCountDownResendOtp;
    this.timerBtnResendOtp = "";
    this.disabledBtnResendOtp = false;
  }

  public confirmFeaSign() {
    let context = this,
      currentDocumentSignature = context.getCurrentDocumentSignature(),
      tag = {
        tag: currentDocumentSignature.sign.tag,
        tagID: currentDocumentSignature.sign.tagID,
        isSigned: currentDocumentSignature.isSigned,
        signatureTime: currentDocumentSignature.signatureTime,
      };

    if (typeof context.otpCodeInput === "undefined" || context.otpCodeInput.trim() === "") {
      this.messageService.add({
        severity: "error",
        summary: context._labelsLocale["documentSign.error"] + ":",
        detail: context._labelsLocale["documentSign.mustInsertOtp"],
      });
      return;
    }

    context.activeLoader = true;

    context.documentSignService.getOAuthToken().pipe(
      concatMap((oauth_token) => {
        if (!oauth_token) {
          context.activeLoader = false;
          this.showError("Oauth token is null or empty")
          return of(null);
        }

        this.OauthToken = oauth_token;

        return context.documentSignService
          .verifyOtpToSignDocumentRequest(
            context._documentUrl,
            tag,
            context.otpCodeInput.trim(),
            this.signAll,
            this.OauthToken
          )
          .pipe(
            concatMap(async response => {
              context.activeLoader = true;

              if (!response.data.signOTPResult) {
                this.messageService.add({
                  severity: "error",
                  summary: context._labelsLocale["documentSign.error"] + ":",
                  detail: context._labelsLocale["documentSign.otpErrorNotValid"],
                });
                context.activeLoader = false;
                return;
              }

              context._signOTPDate =
                typeof response.data.signOTPDate !== "undefined"
                  ? response.data.signOTPDate
                  : "";

              if (context.currentSignature > 0) {
                let imgSign = context.createSignImg();

                let documentSignatureList: any;
                let currentDocumentSignature: any;

                if (this.signAll) {
                  documentSignatureList = context.getDocumentSignatureList();
                  currentDocumentSignature = context.getCurrentDocumentSignature();

                  if (typeof documentSignatureList === "undefined") {
                    this.messageService.add({
                      severity: "error",
                      summary: context._labelsLocale["documentSign.error"] + ":",
                      detail:
                        context._labelsLocale["documentSign.genericErrorOnSignature"],
                    });
                    context.activeLoader = false;
                    return;
                  }
                }
                else {
                  currentDocumentSignature = context.getCurrentDocumentSignature();
                }
                context.activeLoader = true;
                if (typeof currentDocumentSignature === "undefined") {
                  this.messageService.add({
                    severity: "error",
                    summary: context._labelsLocale["documentSign.error"] + ":",
                    detail:
                      context._labelsLocale["documentSign.genericErrorOnSignature"],
                  });
                  context.activeLoader = false;
                  return;
                }

                var totalSignatures: any[] = [];

                if (this.signAll) {
                  totalSignatures = documentSignatureList.filter(
                    signature => signature.sign.signerID == currentDocumentSignature.sign.signerID && !signature.isSigned && signature.type === "FEA"
                  );
                }
                else {
                  totalSignatures.push(currentDocumentSignature);
                }

                for (var i = 0; i < totalSignatures.length; i++) {
                  context.pdfDocBase64 = await context.readerPdfDoc.saveAsBase64({
                    dataUri: false,
                  });
                  context.pdfDoc = await PDFDocument.load(context.pdfDocBase64);

                  let imgScale =
                    totalSignatures[i].scaling != null
                      ? totalSignatures[i].scaling
                      : 0.4
                  let imgTransX = totalSignatures[i].offset.x
                  let imgTransY = totalSignatures[i].offset.y
                  let pagesPdfDoc = await context.pdfDoc.getPages()
                  let pagePdfDoc = pagesPdfDoc[totalSignatures[i].page]
                  let signImagePdfDoc = await context.pdfDoc.embedPng(imgSign)
                  let pngDims = await signImagePdfDoc.scale(imgScale)

                  await pagePdfDoc.drawImage(signImagePdfDoc, {
                    x: totalSignatures[i].x - pngDims.width / 2 + imgTransX,
                    y: totalSignatures[i].y - pngDims.height + imgTransY,
                    width: pngDims.width,
                    height: pngDims.height,
                  });

                  context.pdfDocBase64 = await context.pdfDoc.saveAsBase64({
                    dataUri: false,
                  });
                  context.realPdfDocBase64 = context.pdfDocBase64;
                  context.pdfDoc = await PDFDocument.load(context.pdfDocBase64);
                  context.readerPdfDoc = await PDFDocument.load(
                    context.realPdfDocBase64
                  );

                  totalSignatures[i].isSigned = true;

                  await context.highlightSignature();
                  context.activeLoader = true;
                  context.refreshSignatureDone();
                  context.activeLoader = true;
                  await context.closeDialogSign(true, false);
                  context.activeLoader = true;

                  context._documentSignatures.filter(signature =>
                    signature.id === totalSignatures[i].id)[0].isSigned = true;

                  context.feaTotalSignatures = context._documentSignatures.filter(signature =>
                    signature.type === "FEA" && !signature.isSigned && signature.sign.signerID == currentDocumentSignature.sign.signerID
                  ).length;
                }
              }

              return of(response)
            }),
            catchError((err, caught) => {
              var exception = this.getExceptionMessage(err)
              this.sendError(context._documentUrl, "confirmFeaSign", "verifyOtpToSignDocumentRequest", exception, "catchError");
              return of(null);
            }),
            finalize(() => {
              context.activeLoader = false;
            })
          );

      }),
      catchError((err, caught) => {
        console.error("Error in the chain:", err);
        context.activeLoader = false;
        this.showError(err)
        var exception = this.getExceptionMessage(err)
        this.sendError(context._documentUrl, "confirmFeaSign", "getOAuthToken", exception, "catchError");
        return of();
      }),
      finalize(() => {
        context.activeLoader = false;
      })
    )
      .subscribe();

  }

  public confirmCompleteSignatures() {
    let context = this

    if (context.disabledBtnConfirm) {
      return;
    }
    if (!this.OauthToken) {

      context.documentSignService.getOAuthToken().pipe(
        concatMap((oauth_token) => {
          if (!oauth_token) {
            context.activeLoader = false;
            this.showError("Oauth token is null or empty", true)
            this.sendError(context._documentUrl, "confirmCompleteSignatures", "getOAuthToken", "Oauth token is null or empty", "concatMap => if (!oauth_token)");
            return of();
          }

          context.OauthToken = oauth_token;

          const response = context.applySignDocumentRequest();
          return of(response)

        }),
        catchError((err, caught) => {
          context.activeLoader = false;
          this.showError(err)
          var exception = this.getExceptionMessage(err)
          this.sendError(context._documentUrl, "confirmCompleteSignatures", "getOAuthToken", exception, "catchError");
          return of(null);
        }),
        finalize(() => {
          context.activeLoader = false;
        })
      )
        .subscribe();
    }
    else {
      this.applySignDocumentRequest();
    }
  }

  private applySignDocumentRequest() {
    let context = this,
      tags: Array<TagsSignApply> = [],
      metadata: Array<BaseSignMetadata> = [],
      metadataValues: Array<BaseSignMetadataValues> = [];

    context.activeLoaderConfirmSignature = true;

    tags = context._documentSignatures.map((item) => {
      return {
        tagID: item.sign.tagID,
        tag: item.sign.tag,
        isSigned: item.isSigned,
        signatureTime: item.signatureTime,
      };
    });

    metadata = context.signMetadata.map((item: SignMetadata) => {
      return {
        tag: item.tag,
        metadataID: item.metadataID,
        metadataType: item.metadataType,
        signerID: item.signerID,
        acceptedValues: item.acceptedValues,
        groupName: item.groupName,
        label: item.label,
        isCompleted: item.isCompleted,
        isRequired: item.isRequired,
        order: item.order,
        value: item.value,
        metadataTimeCompleted: item.metadataTimeCompleted,
      };
    });

    metadataValues = context.signMetadataValues.map(
      (item: SignMetadataValues) => {
        return {
          signMetadataID: item.signMetadataID,
          value: item.value,
        };
      }
    );

    const timezone = moment.tz.guess(true);
    // const timezone = "US/Central";

    return context.documentSignService
      .applySignDocumentRequest(
        context._documentUrl,
        timezone,
        tags,
        metadata,
        metadataValues,
        context.pdfDocBase64,
        this.languageSelected,
        this.signAll ?? false,
        this.isFegMode,
        this.OauthToken
      )
      .pipe(
        concatMap(response => {
          context.disabledBtnConfirm = true;

          let message =
            context._fallback != ""
              ? context._labelsLocale[
                "documentSign.documentSignedSuccessfullyWithFallback"
              ].replace("{{fallback}}", context._fallback)
              : context._labelsLocale[
              "documentSign.documentSignedSuccessfully"
              ];

          if (context.isFegMode) {
            if (context._fallback != "") {
              window.location.href = context._fallback;
            }
            context.activeLoaderConfirmSignature = false;
            return of(response);
          }

          context.confirmationService.confirm({
            message: message,
            header: context._labelsLocale["documentSign.documentSigned"],
            icon: "pi pi-check",
            acceptLabel: context._labelsLocale["documentSign.okButton"],
            rejectVisible: false,
            accept: () => {
              if (context._fallback != "") {
                window.location.href = context._fallback;
              }
            },
            reject: () => { },
          });
          context.activeLoaderConfirmSignature = false;

          return of(response)
        }),
        catchError((err, caught) => {
          if (err.error.applicationMessages[0] != null) {
            var code = err.error.applicationMessages[0].code;
            var label_err = "";
            console.log(err.error.applicationMessages[0])
            switch (code) {
              case "-1":
                label_err = "documentSign.refresh_page";
                break;
              default:
                label_err = "documentSign.refresh_page";
            }
            var messageErr = context._labelsLocale[label_err];

            context.confirmationService.confirm({
              message: messageErr,
              header: context._labelsLocale["documentSign.warning"],
              acceptLabel: context._labelsLocale["documentSign.okButton"],
              rejectVisible: false,
              accept: () => {
                window.location.href = window.location.href;
              },
              reject: () => { },
            });
          }
          context.activeLoaderConfirmSignature = false;
          var exception = this.getExceptionMessage(err)
          this.sendError(context._documentUrl, "applySignDocumentRequest", "applySignDocumentRequest", exception, "catchError");
          return of(null);
        }),
        finalize(() => {
        })
      )
      .subscribe();
  }

  public isMobile() {
    return window.innerWidth <= 576;
  }

  public isSmallerScreen() {
    return window.innerHeight <= 480;
  }

  @HostListener("window:resize", ["$event"])
  public resizeCanvas() {
    // 26/05/2022 Inizio: correzione bug 100164
    this.setPdfHeight();
    // 26/05/2022 Fine: correzione bug 100164
    let context = this;
    // https://stackoverflow.com/questions/15875128/is-there-element-rendered-event
    setTimeout(() => {
      if (context.signaturePadElement.nativeElement.offsetParent != null) {
        context.signaturePadElement.nativeElement.width =
          this.signaturePadElement.nativeElement.offsetParent.offsetWidth;
        context.signaturePadElement.nativeElement.height =
          this.signaturePadElement.nativeElement.offsetParent.offsetHeight;
        context.signaturePad.clear(); // otherwise isEmpty() might return incorrect value
      }
    }, 0);
  }

  private showModalDialogFesSign() {
    this.resizeCanvas();
    this.displayModalFesSign = true;
  }

  private hideModalDialogFesSign() {
    this.displayModalFesSign = false;
    this.selectedFesSygnType = null;
    this._typeSignFes = "";
    this.signaturePad.off();
  }

  private showModalDialogFeaSign() {
    this.displayModalFeaSign = true;
  }

  private hideModalDialogFeaSign() {
    this.displayModalFeaSign = false;
    this.confirmTxtOtpSent = "";
    this.otpCodeInput = "";
  }

  private showModalDialogPrivacySign() {
    this.displayModalPrivacySign = true;
  }

  private hideModalDialogPrivacySign() {
    this.displayModalPrivacySign = false;
  }


  private async updateCurrentPage(currentPage: number, forceUpdate: boolean): Promise<void> {
    // 26/05/2022 Inizio: correzione bug 100164
    this.setPdfHeight();
    // 26/05/2022 Fine: correzione bug 100164
    let context = this;
    let updatePage = false
    if (this.signAll) {
      updatePage = context.numberSignaturesDone == context.totalSignatures
    } else {
      updatePage = true
    }

    try {
      if (updatePage || forceUpdate) {
        if (
          typeof context.paginator !== "undefined" &&
          context.paginator != null
        ) {
          context.paginator.changePage(currentPage);
        }
        if (
          typeof context.paginatorMobile !== "undefined" &&
          context.paginatorMobile != null
        ) {
          context.paginatorMobile.changePage(currentPage);
        }
      }
    } catch (exception) {
      console.error(exception);
      this.sendError(context._documentUrl, "updateCurrentPage", "blocco catch", exception, null);

    }
  }

  private toSignMetadataFormGroup(inputs: SignMetadataFormField[]): FormGroup {
    const group: any = {};
    inputs.map((input: SignMetadataFormField) => {
      let validator: ValidatorFn[] = input.isRequired
        ? [Validators.required]
        : [];
      switch (input.validator) {
        case "email":
          validator.push(Validators.email);
          break;
        default:
          break;
      }

      if (input.metadataType == MetadataTypeEnum.CHECKBOX) {
        group[input.key] =
          validator.length > 0
            ? new FormArray([], validator)
            : new FormArray([]);
      } else {
        group[input.key] =
          validator.length > 0
            ? new FormControl(input.value || "", validator)
            : new FormControl(input.value || "");
      }
    });
    return new FormGroup(group);
  }

  private getSignMetadataFormFields(
    fields: Array<SignMetadata>
  ): SignMetadataFormField[] {
    return fields.map((field: SignMetadata) => {
      return {
        tag: field.tag,
        metadataID: field.metadataID,
        metadataType: field.metadataType,
        signerID: field.signerID,
        acceptedValues: field.acceptedValues,
        groupName: field.groupName,
        label: field.label,
        isCompleted: field.isCompleted,
        isRequired: field.isRequired,
        order: field.order,
        value: field.value,
        items: field.items,
        key: field.groupName ?? `field_${field.metadataID}`,
        checked: false,
        // validator: field.validator,
        // options: [],
      };
    });
  }

  private createInputOnMetadataType(data: Array<SignMetadata>) {
    data.sort((x: SignMetadata, y: SignMetadata) => {
      return x.order - y.order;
    });

    let context = this,
      simpleData = data.filter(
        (item: SignMetadata) =>
          item.metadataType !== MetadataTypeEnum.CHECKBOX &&
          item.metadataType !== MetadataTypeEnum.RADIO
      ),
      complexData = data.filter(
        (item: SignMetadata) =>
          item.metadataType == MetadataTypeEnum.CHECKBOX ||
          item.metadataType == MetadataTypeEnum.RADIO
      );

    complexData = complexData.reduce((r, a) => {
      r[a.groupName] = r[a.groupName] || [];
      r[a.groupName].push(a);
      return r;
    }, Object.create(null));

    Object.keys(complexData).forEach((key: string) => {
      if (
        typeof complexData[key][0] != "undefined" &&
        complexData[key].length > 0
      ) {
        const acceptedValues = complexData[key].map((item: SignMetadata) => {
          return item.acceptedValues[0];
        });
        const tmp = {
          tag: complexData[key][0].tag,
          metadataID: complexData[key][0].metadataID,
          metadataType: complexData[key][0].metadataType,
          signerID: complexData[key][0].signerID,
          acceptedValues: acceptedValues, // complexData[key][0].acceptedValues,
          groupName: complexData[key][0].groupName,
          label: complexData[key][0].label,
          isCompleted: complexData[key][0].isCompleted,
          isRequired: complexData[key][0].isRequired,
          order: complexData[key][0].order,
          value: complexData[key][0].value,
          items: complexData[key],
        };
        simpleData.push(tmp);
      }
    });

    simpleData.sort((x: SignMetadata, y: SignMetadata) => {
      return x.order - y.order;
    });

    context.signMetadata = data;
    context.signMetadataFormatted =
      context.getSignMetadataFormFields(simpleData);
    context.formMetadata = context.toSignMetadataFormGroup(
      context.signMetadataFormatted
    );

    if (!context.formMetadata.valid) {
      context.disabledBtnSign = true;
    }
  }

  public inputValueTrimmed(key: string) {
    let context = this;
    context.formMetadata
      .get(key)
      .setValue(context.formMetadata.get(key).value.trim());
  }

  public handleMetadataCheckbox(event: any, key: string, value: string) {
    const formArray: FormArray = this.formMetadata.get(key) as FormArray;
    if (event.checked) {
      formArray.push(new FormControl(value));
    } else {
      let i: number = 0;

      formArray.controls.forEach((ctrl: FormControl) => {
        if (ctrl.value == value) {
          formArray.removeAt(i);
          return;
        }
        i++;
      });
    }
  }

  private getDocumentToBeSigned(guid: string, signer: string) {
    let context = this;
    context.activeLoader = true;

    context.documentSignService
      .getDocumentSignRequest(context._documentUrl)
      .pipe(
        concatMap(async (response: ApiGetDocumentResponse) => {
          context.clinic =
            response.data.clinic != null &&
              typeof response.data.clinic.name !== "undefined"
              ? response.data.clinic.name
              : null;
          context.operator =
            response.data.signOperator != null &&
              typeof response.data.signOperator.name !== "undefined" &&
              response.data.signOperator.surname !== "undefined"
              ? response.data.signOperator.name +
              " " +
              response.data.signOperator.surname
              : null;

          if (response.data.hasAlreadySigned) {
            context.displayModalAlreadySigned = true;
            context.activeLoader = false;
            return;
          }

          let documentExpirationTime = new Date(
            response.data.document.documentExpirationTime
          );
          if (documentExpirationTime.getTime() < new Date().getTime()) {
            context.displayModalDocumentExpired = true;
            context.activeLoader = false;
            return;
          }

          if (
            response.data.signMetadata &&
            response.data.signMetadata.length > 0
          ) {
            context.initialSignMetadata = response.data.signMetadata;
            context.documentHasMetadata = response.data.signMetadata.length > 0;
            context.createInputOnMetadataType(response.data.signMetadata);
          }

          context._documentSignRequest = response.data;
          context.initialPdfDocBase64 =
            context._documentSignRequest.document.content;
          context.pdfDocBase64 = context.initialPdfDocBase64;
          context.realPdfDocBase64 = context.initialPdfDocBase64;
          context.safePdfUrl = context.getSafeUrl(context.pdfDocBase64);
          
          context.pdfDoc = await PDFDocument.load(context.pdfDocBase64);
          context.readerPdfDoc = await PDFDocument.load(
            context.realPdfDocBase64
          );

          try {
            const tags = await context.getSignaturesFromDocument();
            tags.signTags.sort((a, b) => a.signatureOrder - b.signatureOrder);
            context._documentSignatures = tags.signTags;
            context._documentMetadatas = tags.metadataTags;
            context.highlightSignature();
            context.totalSignatures = context._documentSignatures.length;
            context.totalMetadatas = context._documentMetadatas.length;
            context.currentSignature = context.totalSignatures > 0 ? 1 : 0;
            context.firstSignature = context.totalSignatures > 0 ? 1 : 0;
            context.navigationCurrentSignature = context.totalSignatures > 0 ? 1 : 0;
            context.updateCenterRoleLabel();

            let currentSigner = context.getCurrentSigner();
            context.signer =
              currentSigner != null &&
                typeof currentSigner.name !== "undefined" &&
                typeof currentSigner.surname !== "undefined"
                ? currentSigner.name + " " + currentSigner.surname
                : null;
            context.feaTotalSignatures = context._documentSignatures.filter(signature =>
              signature.type === "FEA" && !signature.isSigned && signature.sign.signerID === currentSigner?.signerID
            ).length;
          } catch (reason) {
            console.error(reason);
          }

          context.activeLoader = false;
          return response;
        }),
        catchError((err) => {
          context.activeLoader = false;
          this.showError(err)
          var exception = this.getExceptionMessage(err)
          this.sendError(context._documentUrl, "getDocumentToBeSigned", "getDocumentToBeSigned", exception, "catchError");
          return of();
        }),
        finalize(() => {
          context.activeLoader = false;
        })
      )
      .subscribe();
  }

  private showError(err: any, tokenempty: boolean = false) {
    // Ignora errori di autenticazione già gestiti dal popup dedicato
    if (this.isAuthError(err)) {
      return;
    }

    var show = true;
    this.oauthMessage = "";
    try {
      if (err.includes("where a stream was expected")) {
        show = false
      }
      if (err.includes("Unable to retrieve access token")) {
        tokenempty = true
      }
    } catch (loc_err) { }
    try {
      if (err.message.includes("where a stream was expected")) {
        show = false
      }
      if (err.message.includes("Unable to retrieve access token")) {
        tokenempty = true
      }
    } catch (loc_err) { }

    if (show) {
      this.displayModalError = true
      this.messageTitle = this._labelsLocale["documentSign.error"] + ":"
      this.messageDetail = this._labelsLocale["documentSign.genericError"]

      if (tokenempty) {
        this.oauthMessage = "Riprova più tardi."
      }
    }

  }

  /**
   * Verifica se l'errore è un errore di autenticazione già gestito
   */
  private isAuthError(err: any): boolean {
    if (!err) return false;

    // Errori provenienti da AuthTokenService
    if (err.code && ['CIRCUIT_OPEN', 'TOKEN_ACQUISITION_FAILED', 'MAX_REFRESH_RETRIES_EXCEEDED',
      'MICROSERVICE_UNAUTHORIZED', 'RATE_LIMITED', 'OAUTH_SERVICE_ERROR', 'OAUTH_TIMEOUT'].includes(err.code)) {
      return true;
    }

    // Errori HTTP 401/403/429 dal microservizio
    if (err.status && [401, 403, 429].includes(err.status)) {
      return true;
    }

    return false;
  }


  private confirmSendOtp() {
    let context = this,
      signer = context.getCurrentSigner();
    let currentDocumentSignature: any;
    let signerContacts: SignerContacts;

    currentDocumentSignature = context.getCurrentDocumentSignature();
    signerContacts = context.getSignerContactByType(
      currentDocumentSignature.sign.gateway,
      signer.contacts
    );

    let message_otp = "";

    if (
      signerContacts.contactType == ContactTypeEnum.EMAIL ||
      signerContacts.contactType == ContactTypeEnum.PEC
    ) {
      message_otp = context._labelsLocale[
        "documentSign.messageSendOtpByEmail"
      ].replace("{{emailOtp}}", signerContacts.value);
    } else if (signerContacts.contactType == ContactTypeEnum.SMS) {
      message_otp = context._labelsLocale[
        "documentSign.messageSendOtpByMobile"
      ].replace("{{phoneOtp}}", signerContacts.value);
    }

    context.confirmationService.confirm({
      message: message_otp,
      header: context._labelsLocale["documentSign.titleSendOtp"],
      icon: "pi pi-exclamation-triangle",
      acceptLabel: context._labelsLocale["documentSign.buttonSendOtp"],
      rejectLabel: context._labelsLocale["documentSign.cancel"],
      rejectButtonStyleClass: "btn-cancel",
      accept: () => {
        context.sendOtpToSign();
      },
      reject: () => { },
    });
  }

  private sendOtpToSign() {
    let context = this,
      currentDocumentSignature = context.getCurrentDocumentSignature(),
      tag: SimpleTag = {
        tagID: currentDocumentSignature.sign.tagID,
        tag: currentDocumentSignature.sign.tag,
      };

    context.activeLoader = true;
    context.documentSignService
      .sendOtpToSignDocumentRequest(
        context._documentUrl,
        tag,
        this.languageSelected,
        this.signAll ?? false
      )
      .pipe(
        tap((response) => {
          if (!response.data.sent) {
            return of();
          }

          if (typeof response.data.signerTag.signerID === "undefined") {
            return of();
          }

          if (
            response.data.signerTag.signerID !=
            currentDocumentSignature.sign.signerID
          ) {
            return of();
          }

          let tagResponse = context.getObjectFromList(
            currentDocumentSignature.sign.tagID,
            "tagID",
            response.data.signerTag.tags
          );

          if (typeof tagResponse === "undefined") {
            return of();
          }

          if (tagResponse.tagID != currentDocumentSignature.sign.tagID) {
            return of();
          }

          let signer = context.getCurrentSigner(),
            signerContacts = context.getSignerContactByType(
              currentDocumentSignature.sign.gateway,
              signer.contacts
            );

          if (signerContacts.contactType == ContactTypeEnum.EMAIL) {
            context.confirmTxtOtpSent = context._labelsLocale[
              "documentSign.otpSentToEmail"
            ].replace("{{email}}", signerContacts.value);
          } else if (signerContacts.contactType == ContactTypeEnum.SMS) {
            context.confirmTxtOtpSent = context._labelsLocale[
              "documentSign.otpSentToMobile"
            ].replace("{{mobile}}", signerContacts.value);
          }

          context.showModalDialogFeaSign();
        }),
        catchError((err, caught) => {
          var exception = this.getExceptionMessage(err)
          this.sendError(context._documentUrl, "sendOtpToSign", "sendOtpToSignDocumentRequest", exception, "catchError");
          return of();
        }),
        finalize(() => {
          context.activeLoader = false;
        })
      )
      .subscribe();
  }

  private searchTagPdfInDocumentRequest(tag: string, signatures: Array<any>) {
    return this.getObjectFromList(tag, "tag", signatures);
  }

  private getSignerFromDocumentRequest(
    signerID: string,
    signers: Array<DocumentSigner>
  ) {
    return this.getObjectFromList(signerID, "signerID", signers);
  }

  private getObjectFromList(match: string, key: string, list: Array<any>) {
    for (let i = 0; i < list.length; i++) {
      if (list[i][key] == match) {
        return list[i];
      }
    }
  }

  private getSignerContactByType(
    contactType: string,
    signerContacts: Array<SignerContacts>
  ) {
    for (let i = 0; i < signerContacts.length; i++) {
      if (signerContacts[i].contactType === contactType) {
        return signerContacts[i];
      }
    }
  }

  private async getSignaturesFromDocument() {
    // Configure PDF.js worker
    pdfjs.GlobalWorkerOptions.workerSrc = "/assets/worker/pdf.worker.js";

    // Disable sandboxing features for security
    if (typeof window !== 'undefined') {
      (window as any).pdfjsWorker = {
        isMainThread: true
      };
    }

    let context = this

    // Secure configuration for PDF loading
    const loadingTask = pdfjs.getDocument({
      data: atob(context.pdfDocBase64),
      disableAutoFetch: true,
      disableRange: true,
      disableStream: true,
      isEvalSupported: false,
      fontExtraProperties: false,
      disableFontFace: true,
      ignoreErrors: true
    });

    let pdf = await loadingTask.promise;
    let listSignTags = []
    let listMetadataTags = []
    let counterSignature = 1
    let counterMetadata = 1

    // calculate total count for document
    let maxPages = pdf.numPages;
    var countPromises = []; // collecting all page promises
    for (let j = 1; j <= maxPages; j++) {
      let page = pdf.getPage(j),
        realNumPage = j - 1,
        tagObj: TagObj = { signTags: [], metadataTags: [] };

      countPromises.push(
        page.then((page) => {
          // add page promise
          return page.getTextContent().then((page) => {
            // return content promise
            for (let i = 0; i < page.items.length; i++) {
              let matchSign = context.searchTagPdfInDocumentRequest(
                page.items[i].str,
                context._documentSignRequest.signType
              );
              let matchMetadata = context.searchTagPdfInDocumentRequest(
                page.items[i].str,
                context._documentSignRequest.signMetadata
              );

              if (
                typeof matchSign !== "undefined" &&
                matchSign != null &&
                !context.checkTagAlreadyExists(tagObj.signTags, matchSign.tag)
              ) {
                listSignTags.push({
                  type: matchSign.type,
                  page: realNumPage,
                  x: page.items[i].transform[4],
                  y: page.items[i].transform[5],
                  scaling: context.getScalingTag(matchSign.tag),
                  offset: context.getOffsetTag(matchSign.tag, matchSign.type),
                  id: matchSign.tagID,
                  isSigned: false,
                  signatureTime: null,
                  sign: matchSign,
                  signatureOrder: context.getOrderSignatureTag(
                    counterSignature,
                    matchSign.tag,
                    tagObj.signTags
                  ),
                });
                counterSignature++;
              }
              if (
                typeof matchMetadata !== "undefined" &&
                matchMetadata != null
              ) {
                listMetadataTags.push({
                  type: matchMetadata.metadataType,
                  page: realNumPage,
                  x: page.items[i].transform[4],
                  y: page.items[i].transform[5],
                  scaling: context.getScalingTag(matchMetadata.tag),
                  offset: context.getOffsetTag(
                    matchMetadata.tag,
                    matchMetadata.metadataType
                  ),
                  id: matchMetadata.tagID,
                  isCompleted: false,
                  signatureTime: null,
                  metadata: matchMetadata,
                });

                counterMetadata++;
              }
            }
            tagObj.signTags = listSignTags;
            tagObj.metadataTags = listMetadataTags;

            return tagObj;
          });
        })
      );
    }
    // Wait for all pages and get all matches
    return Promise.all(countPromises).then((tagsObj: TagObj[]) => {
      let signTags: any[] = [];
      let metadataTags: any[] = [];
      tagsObj.forEach((tagObj) => {
        if (tagObj.signTags.length > 0) signTags = tagObj.signTags;

        if (tagObj.metadataTags.length > 0)
          metadataTags = tagObj.metadataTags;
      });

      const result: TagObj = {
        signTags: signTags.sort((a, b) => parseInt(a.id) - parseInt(b.id)),
        metadataTags: metadataTags.sort(
          (a, b) => parseInt(a.id) - parseInt(b.id)
        ),
      };
      return result;
    });
  }

  private checkTagAlreadyExists(tagsList: Array<any>, tag: string) {
    let result = false;
    if (typeof tag !== "undefined" && tag != null && tag != "") {
      let check = tagsList.find((item) => item.sign.tag === tag);
      result =
        typeof check !== "undefined" &&
          check != null &&
          typeof check.sign.tag !== "undefined" &&
          check.sign.tag != null
          ? true
          : false;
    }
    return result;
  }

  private createSignImg() {
    const timezone = moment.tz.guess(true);
    // const timezone = "US/Central";

    let context = this,
      message = "",
      newLine = "\r\n",
      dateOptions: Intl.DateTimeFormatOptions = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: timezone,
      },
      currentDocumentSignature = context.getCurrentDocumentSignature(),
      signer = context.getCurrentSigner(),
      dateSignature = new Date();
    message +=
      signer.name.toUpperCase() + " " + signer.surname.toUpperCase() + newLine;
    message +=
      context._labelsLocale["documentSign.date"] +
      ": " +
      dateSignature.toLocaleString("it-IT", dateOptions) +
      newLine;

    currentDocumentSignature.signatureTime = dateSignature.toUTCString();

    if (currentDocumentSignature.sign.type == SignTypeEnum.FEA) {
      if (!isNaN(Date.parse(context._signOTPDate))) {
        message +=
          context._labelsLocale["documentSign.otp"] +
          ": " +
          new Date(context._signOTPDate).toLocaleString("it-IT", dateOptions) +
          newLine;
      }

      if (this.signAll) {
        context._documentSignatures.filter(
          signature => signature.sign.signerID == currentDocumentSignature.sign.signerID && !signature.isSigned && signature.type === "FEA"
        ).forEach(function (current) {
          current.signatureTime = currentDocumentSignature.signatureTime;
        });

      }
    }

    message += context._labelsLocale[
      "documentSign.signatureDoneDigitally"
    ].replace("{{typeSign}}", currentDocumentSignature.sign.type);
    CanvasTextWrapper(context.signatureCanvasElement.nativeElement, message, {
      strokeText: true,
    });
    return context.signatureCanvasElement.nativeElement.toDataURL();
  }

  private createMetadataImg(value) {
    let context = this;
    let message = value;

    CanvasTextWrapper(context.metadataCanvasElement.nativeElement, message, {
      strokeText: true,
    });
    return context.metadataCanvasElement.nativeElement.toDataURL();
  }

  private createCheck() {
    let context = this;
    let message = "X";
    let currentDocumentSignature = context.getCurrentDocumentSignature();
    let dateSignature = new Date();

    currentDocumentSignature.signatureTime = dateSignature.toUTCString();

    CanvasTextWrapper(context.signatureCanvasElement.nativeElement, message, {
      strokeText: true,
    });
    return context.signatureCanvasElement.nativeElement.toDataURL();
  }

  private clearCanvasCheck() {
    this.signatureXElement.nativeElement
      .getContext("2d")
      .clearReact(
        0,
        0,
        this.signatureXElement.nativeElement.width,
        this.signatureXElement.nativeElement.height
      );
  }

  private async clearCanvasSignImg() {
    await this.signatureCanvasElement.nativeElement
      .getContext("2d")
      .clearRect(
        0,
        0,
        this.signatureCanvasElement.nativeElement.width,
        this.signatureCanvasElement.nativeElement.height
      );
  }

  private clearCanvasMetadataImg() {
    this.metadataCanvasElement.nativeElement
      .getContext("2d")
      .clearRect(
        0,
        0,
        this.metadataCanvasElement.nativeElement.width,
        this.metadataCanvasElement.nativeElement.height
      );
  }

  private refreshSignatureDone() {
    let context = this;
    context.activeLoader = true;
    context.numberSignaturesDone++;

    if (context.numberSignaturesDone > 0) {
      context.disabledInputMetadata = true;
      context.disabledBtnApplyMetadata = true;
      context.disabledBtnClearMetadata = true;
    }

    if (context.numberSignaturesDone == context.totalSignatures) {
      context.disabledBtnSign = true;
      context.disabledBtnPrivacy = true;
      context.disabledBtnConfirm = false;
      this.confirmCompleteSignatures();
    }
    context.activeLoader = false;
  }

  private getIndexCurrentSignature() {
    return this.currentSignature - 1;
  }

  private getCurrentSigner() {
    let context = this,
      currentDocumentSignature = context.getCurrentDocumentSignature();
    return currentDocumentSignature != null &&
      typeof currentDocumentSignature !== "undefined"
      ? context.getSignerFromDocumentRequest(
        currentDocumentSignature.sign.signerID,
        context._documentSignRequest.document.signers
      )
      : null;
  }

  public getFegSignatureRoleLabel(): string {
    const currentSigner = this.getCurrentSigner();
    if (currentSigner?.signerType === SignerTypeEnum.PAT) {
      return "PAZIENTE";
    }
    return "OPERATORE";
  }

  private updateCenterRoleLabel(): void {
    if (this.isFegMode && this.totalSignatures > 0) {
      this.breadcrumbService.setCenterLabel(this.getFegSignatureRoleLabel());
      return;
    }
    this.breadcrumbService.setCenterLabel("");
  }

  private getCurrentDocumentSignature() {
    let context = this,
      indexSign = context.getIndexCurrentSignature();
    return context._documentSignatures[indexSign];
  }

  private getDocumentSignatureList() {
    let context = this;
    let indexSign = context.getIndexCurrentSignature();
    let currentDocumentSignature = context._documentSignatures[indexSign];
    let signerID = currentDocumentSignature.sign.signerID;
    return context._documentSignatures.filter(x => x.sign.signerID == signerID);
  }

  private getOrderSignatureTag(
    defaultOrder: number,
    signTag: string,
    tagsList: Array<any>
  ) {
    let order = defaultOrder;
    if (typeof signTag !== "undefined" && signTag.indexOf("sq=") !== -1) {
      let splitTagBySequence = signTag.split("sq=");
      if (
        typeof splitTagBySequence[1] !== "undefined" &&
        splitTagBySequence[1] != null &&
        splitTagBySequence[1] != ""
      ) {
        let sequence = parseInt(splitTagBySequence[1].replace(/\`/gi, ""));
        let check =
          typeof sequence !== "undefined" && sequence != null && sequence > 0
            ? tagsList.find((item) => item.signatureOrder === sequence)
            : null;
        if (check == null) {
          order = sequence;
        }
      }
    }
    return order;
  }

  private getScalingTag(tag: string) {
    let scaling = null;
    if (typeof tag !== "undefined" && tag.indexOf("scaling=") !== -1) {
      let tempTag = tag.endsWith(",") ? tag : tag + ",";
      let tagScaling = tempTag.substring(
        tempTag.lastIndexOf("scaling=") + "scaling=".length,
        tempTag.lastIndexOf(",")
      );
      if (!isNaN(parseFloat(tagScaling))) {
        scaling = parseFloat(tagScaling) > 0 ? parseFloat(tagScaling) : null;
      }
    }
    return scaling;
  }

  private getOffsetTag(tag: string, signType: string) {
    let offset = { x: 0, y: 0 };

    switch (signType) {
      case SignTypeEnum.FEA:
        offset.x = 185;
        offset.y = 10;
        break;
      case SignTypeEnum.FES:
        offset.x = 135;
        offset.y = 45;
        break;
      case SignTypeEnum.PRIVACY:
        offset.x = 149;
        offset.y = 37;
        break;
      default:
        offset.x = 185;
        offset.y = 5;
    }

    if (typeof tag !== "undefined" && tag.indexOf("offset=") !== -1) {
      let tempSignTag = tag.endsWith(",") ? tag : tag + ",";
      let tagOffset = tempSignTag.substring(
        tempSignTag.lastIndexOf("offset=") + "offset=".length,
        tempSignTag.lastIndexOf(",")
      );
      let coordinatesOffset = tagOffset.split(".");
      if (
        typeof coordinatesOffset[0] !== "undefined" &&
        !isNaN(parseInt(coordinatesOffset[0]))
      ) {
        offset.x = parseInt(coordinatesOffset[0]);
      }
      if (
        typeof coordinatesOffset[1] !== "undefined" &&
        !isNaN(parseInt(coordinatesOffset[1]))
      ) {
        offset.y = parseInt(coordinatesOffset[1]);
      }
    }
    return offset;
  }

  private async highlightSignature() {
    // Se siamo in modalità FEG, non mostriamo i riquadri rossi (placeholder) e NON modifichiamo il PDF
    if (this.isFegMode) {
        // Se necessario, carichiamo comunque il doc per coerenza interna, ma senza salvarlo/modificarlo
        // context.pdfDoc = await PDFDocument.load(context.initialPdfDocBase64); 
        return;
    }

    let context = this
    let pagesPdfDoc = await context.pdfDoc.getPages()
    let rectangleWidth = 225
    let rectangleHeight = 40

    await context.pdfDoc.saveAsBase64({
      dataUri: false,
    });
    context._documentSignatures.forEach((signature) => {
      if (!signature.isSigned) {
        let pagePdfDoc = pagesPdfDoc[signature.page];
        pagePdfDoc.drawText("" + signature.signatureOrder, {
          x: signature.x - rectangleWidth / 2 + signature.offset.x,
          y: signature.y - rectangleHeight / 2 + signature.offset.y,
          size: 11,
          color: rgb(1, 0, 0),
        });
        pagePdfDoc.drawRectangle({
          x: signature.x - rectangleWidth / 2 + signature.offset.x - 35,
          y: signature.y - rectangleHeight + signature.offset.y,
          width: rectangleWidth,
          height: rectangleHeight,
          borderColor: rgb(1, 0, 0),
          borderWidth: 0.75,
          borderDashArray: [10],
        });
      }
    });

    // load multiple times to avoid incorrect version loaded during the "sign all" process
    await context.pdfDoc.saveAsBase64({
      dataUri: false,
    });

    context.pdfDocBase64 = await context.pdfDoc.saveAsBase64({
      dataUri: false,
    });
    context.pdfDoc = await PDFDocument.load(context.pdfDocBase64);
  }

  private async drawMultipleMetadataImages(metadataImages: Array<any>) {
    let context = this;
    context.pdfDoc = await PDFDocument.load(context.initialPdfDocBase64);
    const pdfDocPages = await context.pdfDoc.getPages();

    const metadataPromises: Promise<string>[] = metadataImages.map(
      async (metadataImage: any) => {
        const pdfMetadataPage = pdfDocPages[metadataImage.page];
        const embedImage = await context.pdfDoc.embedPng(metadataImage.content);
        const imageDims = await embedImage.scale(metadataImage.scale);

        await pdfMetadataPage.drawImage(embedImage, {
          x: metadataImage.x - imageDims.width / 2 + metadataImage.transX,
          y: metadataImage.y - imageDims.height + metadataImage.transY,
          width: imageDims.width,
          height: imageDims.height,
        });

        return await context.pdfDoc.saveAsBase64({ dataUri: false });
      }
    );

    const resultPdfUpdate: Array<string> = await Promise.all(metadataPromises);
    const pdfContentBase64 = resultPdfUpdate[resultPdfUpdate.length - 1];

    await context.updatePdfAfterDrawn(pdfContentBase64);
  }

  private async updatePdfAfterDrawn(contentBase64?: string) {
    let context = this;
    if (this.isFegMode) {
        // In FEG mode, se arriva un contentBase64 (es. dopo firma), lo usiamo.
        // Altrimenti non facciamo nulla per evitare di sovrascrivere con versioni "sporche"
        if (typeof contentBase64 !== "undefined" && contentBase64 != "") {
            context.pdfDocBase64 = contentBase64;
            context.realPdfDocBase64 = contentBase64;
            context.safePdfUrl = context.getSafeUrl(context.pdfDocBase64);
            // Ricarichiamo anche pdfDoc per eventuali operazioni future, ma non salviamo
            context.pdfDoc = await PDFDocument.load(context.pdfDocBase64);
            context.readerPdfDoc = await PDFDocument.load(context.realPdfDocBase64);
        }
        return;
    }

    if (typeof contentBase64 !== "undefined" && contentBase64 != "") {
      context.pdfDocBase64 = contentBase64;
      context.realPdfDocBase64 = contentBase64;
    } else {
      context.pdfDocBase64 = await context.pdfDoc.saveAsBase64({
        dataUri: false,
      });
      context.realPdfDocBase64 = context.pdfDocBase64;
    }
    context.pdfDoc = await PDFDocument.load(context.pdfDocBase64);
    context.readerPdfDoc = await PDFDocument.load(context.realPdfDocBase64);
    context.highlightSignature();
  }

  public closeModal() {
    this.displayModalError = false;
  }

  private getExceptionMessage(err: any): string {
    if (typeof err === 'string') {
      return err;
    } else if (typeof err === 'object' && err !== null && 'message' in err) {
      return err.message;
    } else {
      return '';
    }
  }

  private anyToStringJSON(obj: any): string {
    if (typeof obj === 'string') {
      return obj;
    } else if (typeof obj === 'object') {
      return JSON.stringify(obj);
    } else {
      return '';
    }
  }

  public sendError(
    url: string,
    method: string,
    step: string,
    exception: string,
    note: string | null
  ) {
    let context = this;
    context.documentSignService.sendErrorLog(
      url,
      method,
      step,
      exception,
      note
    ).pipe(
      concatMap(async (response) => {
        console.log(response)
      }),
      catchError((err, caught) => {
        return of();
      }),
      finalize(() => {
      })
    )
      .subscribe();
  }

  public getSafeUrl(base64: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + base64);
  }
}
